module.exports = __webpack_public_path__ + "img/oddnary-purple-scheme-1.fa1f4be8.jpg";